import React, { Component } from 'react';
import './footer.css';


class Footer extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }
    render() {
        return (
            <footer>
                Made by <a href="http://shubhamdeshkar.com" target="_blank" rel="noopener noreferrer">Shubham Deshkar</a> &#169; 2021 shubhamdeshkar.com
            </footer>
        );
    }
}

export default Footer;